export const ACTION_CONTACT_US__REQUEST = 'ACTION_CONTACT_US__REQUEST';
export const ACTION_CONTACT_US__SUCCESS = 'ACTION_CONTACT_US__SUCCESS';
export const ACTION_CONTACT_US__FAIL = 'ACTION_CONTACT_US__FAIL';
